/* eslint-disable import/no-unresolved */
import CustomTextField from "src/shared/CustomTextField";

interface Props {
  formik: any;
}

function OccupationDetails({ formik }: Props) {
  return (
    <div>
      <div>
        <p className="text-daintree font-montserrat text-sm font-medium mb-4">
          What is your occupation & also mention your occupational duties and responsibilities?*
        </p>
      </div>
      <div className="md:w-477/1000">
        <CustomTextField
          requiredStar
          label="Enter"
          className=""
          // onChange={handleChange("occupationDetails.occupationNameAndRole")}
          onChange={formik.handleChange}
          handleBlur={formik.handleBlur}
          value={formik.values.occupationDetails?.occupationNameAndRole}
          name="occupationDetails.occupationNameAndRole"
          error={formik.errors.occupationDetails?.occupationNameAndRole}
          touched={formik.touched.occupationDetails?.occupationNameAndRole}
        />
      </div>
    </div>
  );
}

export default OccupationDetails;
